//Angular imports
import { Injectable } from '@angular/core';

// Design System imports
import { ToastService } from '@ciranet/ui';

@Injectable({
  providedIn: 'root'
})
export class ClientErrorService {
  constructor(private readonly toastService: ToastService) {}

  displayError(error: Error) {
    this.toastService.error(error.message);
  }
}
